import { Box, SxProps } from "@mui/material";
import classNames from "classnames";
import { PropsWithChildren } from "react";

export const ViewContainer = ({
  children,
  className,
  sx,
}: PropsWithChildren<{ className?: string; sx?: SxProps }>) => {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        ...sx,
      }}
      className={classNames("view-root", className)}
    >
      {children}
    </Box>
  );
};
